import Header from '../../components/Header'
import Dvr from '../../components/identidades/Dvr';

function DdvrPage() {
    window.scrollTo(0, 0);
    return (
        <div>
            <Header isComunicacao={true}></Header>
            <Dvr></Dvr>
        </div>
    )
}

export default DdvrPage;